import styled from "styled-components";
import {
  DefaultParagraphMediumFactory,
  DefaultTitleSmallFactory,
} from "../../../../components/Habitacional/core/Typograph/Typograph.Style";

export const AdvantagesSectionContainer = styled.section(({ theme }) => ({
  backgroundColor: `${theme.color.brandPrimary.light} !important`,
  color: theme.color.neutral["08"],
  marginBottom: "0 !important",
}));

export const AdvantagesSectionContent = styled.div(() => ({
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "column",
  gap: "32px",

  paddingTop: "40px",
  paddingBottom: "40px",

  "@media (min-width: 992px)": {
    paddingTop: "60px",
    paddingBottom: "60px",
    flexDirection: "row",
  },
}));

export const AdvantagesSectionItem = styled.div(() => ({
  display: "flex",
  alignItems: "flex-start",
  gap: "32px",

  maxWidth: "100%",
  width: "100%",

  "@media (min-width: 992px)": {
    maxWidth: "384px",
  },

  svg: {
    width: "60px",
    height: "60px",
  },

  div: {
    flex: 1,
  },
}));

export const AdvantagesSectionItemContent = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
}));

export const AdvantagesSectionItemTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleSmallFactory({ theme }),
  fontWeight: "500",
}));

export const AdvantagesSectionItemDescription = styled.p(({ theme }) => ({
  ...DefaultParagraphMediumFactory({ theme }),
}));
